module.exports = __webpack_public_path__ + "img/J13186.93861af6.png";